import React, {
    Component
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles';

import Auth from '@aws-amplify/auth';

import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import ButtonBase from '@material-ui/core/ButtonBase';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import CircularProgress from '@material-ui/core/CircularProgress';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import isEmail from 'validator/lib/isEmail';

import { actionTypes } from '~/constants';
import ButtonProgress from '~/widgets/button-progress';


class LoginContainer extends Component {
    constructor() {
        super()
        this.state = {
            error: null,
            step: 1,
            email: '',
            password: '',
            spinning: false,
            showPassword: false,
        }
    }

    componentWillMount() {
        let email = window.localStorage.getItem('email');
        if(email){
            this.setState({
                email,
                step: 2
            })
        }
        window.Auth = Auth;
    }

    componentDidUpdate() {
        if(this.props.user.CognitoUser !== null){
            this.props.history.push(`/app/departments`)
        }
    }

    async handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation()
        if(this.state.step === 1){
            if(!isEmail(this.state.email)){
                this.setState({
                    error: 'The email you entered is invalid.'
                })
                return;
            }
            this.setState({
                step: 2,
                error: null,
                password: '',
            })
        }else if(this.state.step === 2){
            if(this.state.password === ''){
                return;
            }
            try {
                this.setState({
                    spinning: true
                })
                await Auth.signIn(this.state.email, this.state.password);
                console.log('success!')
            } catch(err){
                console.error(err);
                this.setState({
                    error: err.message
                })
            } finally {
                this.setState({
                    spinning: false
                })
            }
        }
        return;
    }

    render() {
        let buttonClasses = (this.state.step === 1 && this.state.email !== '') || (this.state.step === 2 && this.state.password !== '') ? 'button-primary' : 'button-disabled';

        let stepForm = (
            <div className="login-form-fields">
                <FormControl className={`form-control ${this.state.email ? 'filled-in' : null}`}>
                    <InputLabel htmlFor="email" className="form-label">
                        Email
                    </InputLabel>
                    <Input
                        autoFocus
                        autoComplete="username"
                        name="email"
                        className="input"
                        type="text"
                        classes={{root: 'input-root'}}
                        value={this.state.email}
                        onChange={(e)=>{this.setState({error: null, email: e.target.value})}}
                    />
                </FormControl>
            </div>
        )
        if(this.state.step === 2){
            stepForm = (
                <div className="login-form-fields">
                    <Chip
                        icon={<AccountCircleIcon className="account-icon"/>}
                        deleteIcon={<KeyboardArrowDownIcon/>}
                        label={this.state.email}
                        onClick={()=>{this.setState({step: 1})}}
                        onDelete={()=>{this.setState({step: 1})}}
                        variant="outlined"
                        className="login-chip"
                    />
                    <FormControl className={`form-control ${this.state.password ? 'filled-in' : null}`}>
                        <input type="text" autoComplete="username" name="username" value={this.state.email} style={{display: 'none'}}/>
                        <InputLabel htmlFor="password" className="form-label">
                            Password
                        </InputLabel>
                        <Input
                            autoFocus
                            autoComplete="current-password"
                            className="input"
                            name="password"
                            type={this.state.showPassword ? 'text' : 'password'}
                            classes={{root: 'input-root'}}
                            value={this.state.password}
                            onChange={(e)=>{this.setState({error: null, password: e.target.value})}}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="Toggle password visibility"
                                        onClick={()=>{this.setState({showPassword: !this.state.showPassword})}}
                                    >
                                      {this.state.showPassword ? <VisibilityIcon/> : <VisibilityOffIcon/>}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </FormControl>
                </div>
            )
        }

        return (
            <div className="wrapper wrapper-login flex-vertical">
                <div className="card card-login">
                    <div className="login-logo">
                        <img alt="eXmarX" src="/dist/assets/img/exmarx-logo.png"/>
                    </div>
                    <form className="login-form" onSubmit={this.handleSubmit.bind(this)}>
                        <div className="login-heading">
                            <h1>Sign in</h1>
                            <div className="login-subheading">
                                to continue to eXmarX
                            </div>
                        </div>
                        {this.state.error !== null ? (
                            <div className="error-panel">
                                <div className="error-icon">
                                    <img src={`/dist/assets/img/ic-error.svg`} />
                                </div>
                                <div className="error-message">
                                    {this.state.error}
                                </div>
                            </div>
                        ): null }
                        {stepForm}
                        <div>
                            <ButtonProgress className={`button ${buttonClasses}`} type="submit" spinning={this.state.spinning}>
                                Next
                            </ButtonProgress>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

import { connect } from 'react-redux'
export default connect(
    (state)=>{
        return {
            user: state.user,
        }
    },
    (dispatch)=>{
        return {
            dispatch: dispatch
        }
    }
)(LoginContainer);